import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class ClasificacionProductosService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  getClasificacionProductos(){
    return this.http.get(`${this.API_URI}/productos-clasificaciones`)
  }

  getClasificacionProducto(id:string){
    return this.http.get(`${this.API_URI}/productos-clasificaciones/${id}`);
  }

  actualizarClasificacionProducto(id: string | number, datos: any): Observable<any> {
    return this.http.put(`${this.API_URI}/productos-clasificaciones/${id}`, datos);
  }
  
  crearClasificacionProducto(datos: any) {
    return this.http.post(`${this.API_URI}/productos-clasificaciones`, datos);
  }

  eliminarClasificacionProducto(id: string): Observable<any> {
    return this.http.delete(`${this.API_URI}/productos-clasificaciones/${id}`);
  }

}
